import './HitText.css'

import React from 'react'
import { HIG_HIT, LOW_HIT, MID_HIT } from "@/services/repository/hits"


export function hitClassColor(value: number): string {
    value = Math.abs(value)
    if (value === undefined) {
        return ''
    }
    if (value > HIG_HIT) {
        return 'hittext-maker-hig-worn'
    }
    if (value > MID_HIT) {
        return 'hittext-maker-mid-worn'
    }
    if (value > LOW_HIT) {
        return 'hittext-maker-low-worn'
    }
    return ''
}

interface HitValueProps {
  value: number;
  children: React.ReactNode;
}

export const HitText: React.FC<HitValueProps> = ({ value, children }) => (
  <span className={hitClassColor(value)}>
    {children}
  </span>
);